import { useChannelTalk } from '@repo/channel-talk';
import { Button, Description, TopNavigation } from '@zenterprise-inc/ui';
import { MouseEvent, ReactElement, useCallback } from 'react';

import { SUPPORT_BOT_LINK } from '@/lib/constants/link';
import { useExitService } from '@/lib/hooks/use-exit-service';

type ErrorPageLayoutProps = {
  title: string;
  message: string;
  buttonText?: string;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  onClose?: () => void;
  children?: ReactElement;
  isRightButton?: boolean;
};

export default function ErrorPageLayout({ title, message, buttonText = '뒤로가기', onClick, onClose, children, isRightButton = true }: ErrorPageLayoutProps) {
  const { openChannelTalk } = useChannelTalk();
  const { exitService } = useExitService();

  const handleClose = useCallback(() => {
    if (onClose) {
      onClose();
    } else {
      exitService();
    }
  }, [exitService, onClose]);
  const handleAsk = () => {
    openChannelTalk(SUPPORT_BOT_LINK.errors);
  };

  return (
    <div className={'w-full flex-1 flex flex-col'}>
      {isRightButton ? (
        <TopNavigation.Basic rightTextButton={{ label: '나가기', onClick: handleClose }} className={'max-w-[1024px] mx-auto'} />
      ) : (
        <TopNavigation.Basic className={'max-w-[1024px] mx-auto'} />
      )}
      <main className={'w-full max-w-[520px] mx-auto flex flex-col flex-1 justify-center pb-12'}>
        <div className={'flex flex-col flex-1 justify-center items-center'}>
          <Description>
            <Description.Guide subTitle={title} description={message} buttonContent={buttonText} button={{ state: 'secondary', onClick }} />
          </Description>
        </div>
        <div className={'flex justify-center items-center mt-auto'}>
          <span className={'mr-[10px] body-14 text-gray-700'}>같은 문제가 반복되시나요?</span>
          <Button.Box state={'secondary'} size={'small'} onClick={handleAsk}>
            문의하기
          </Button.Box>
        </div>
      </main>
      {children}
    </div>
  );
}
